// path: store/pool/pool.ts (module)

import { getStoreBuilder, BareActionContext } from "vuex-typex"
import Vuex, { Store } from "vuex"
import{Image} from '../api/index'
import NewApi from '@/ts/api'

export interface RootState { basket: ImageState}

export interface ImageState { images: Image[]}

const initialBasketState: ImageState = { images: []}
export  const builder =  getStoreBuilder<RootState>()
 const b = builder.module("pool", initialBasketState)

// getters
const itemsGetter = b.read(state => state.images, "images")

// mutations
function appendItem(state: ImageState, payload: Image )
{
    state.images.push(payload)
}


// action
async function restoreSavedBasket(context: BareActionContext<ImageState, RootState>)
{
    try
    {
        let api = NewApi()
        let res = await api.imageGet()
        let images = res.data
        images.forEach(item => pool.commitAppendImage(item))
        console.log("images updated")
    }catch(e){
      console.error("could not fetch images: " + e)
    }
}

// state
const stateGetter = b.state()

// exported "pool" module interface
const pool = {
    // state
    get state() { return stateGetter() },
    
    // getters (wrapped as real getters)
    get images() { return itemsGetter() },

    // mutations
    commitAppendImage: b.commit(appendItem),

    // actions
    dispatchRestoreSavedBasket: b.dispatch(restoreSavedBasket)
}

export default pool